module.exports = __webpack_public_path__ + "static/img/toolsbanner.a4a8c77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/toolsbanner.png
// module id = gUfo
// module chunks = 1